export default "__VITE_ASSET__Bvo37AGS__"